export default "__VITE_ASSET__d8777642__"